import React from 'react';
import { AnimatedHeaderButtonView } from './view';
import { styles } from './styles';

export class AnimatedHeaderButton extends React.Component {
  render() {
    return <AnimatedHeaderButtonView {...this.props} styles={styles} />;
  }
}
